// threeDSelectors.ts
import { createSelector } from "@reduxjs/toolkit";
import { selectDebugThreeDItems } from "../DebugSlice";
import { computeFootprintPolygon, IPolygon } from "./geometryToPolygon";
import { IRootState } from "../../app/store";

// 🆕 Selector för 3D-statistik
export const selectThreeDStatistics = createSelector(selectDebugThreeDItems, (threeDItems) => {
  let totalItems = threeDItems.length;
  let totalGeometries = 0;
  let totalPoints = 0;
  let totalNormals = 0;
  let totalTriangles = 0;

  threeDItems.forEach((item) => {
    totalGeometries += item.geometries.length;
    item.geometries.forEach((geom) => {
      // vertexData: 6 floats per vertex (3 pos + 3 norm)
      const numVertices = geom.vertexData.length / 6;
      totalPoints += numVertices * 3; // 3 coords per point
      totalNormals += numVertices * 3; // 3 per normal
      totalTriangles += geom.indexData.length / 3; // 3 index per triangle
    });
  });

  return {
    totalItems,
    totalGeometries,
    totalPoints,
    totalNormals,
    totalTriangles,
  };
});

// Samma typ som JSON:et ungefär
export interface IDebugGeometryItem {
  expressId: number;
  globalId: string;
  instanceClass: string;
  geometries: Array<{
    geometryExpressID: number;
    transformationMatrix: number[];
    vertexData: number[];
    indexData: number[];
  }>;
}

// Output-type for 2D-fotavtrykk
export interface IDebugFootprintPolygon {
  expressId: number;
  globalId: string;
  geometryExpressId: number;
  polygon: IPolygon;
}

// 3) Konverter alle geometrier til 2D-polygoner via util-funksjonen
export const selectDebugFootprintPolygons = createSelector(
  [selectDebugThreeDItems],
  (items): IDebugFootprintPolygon[] =>
    items.flatMap((item) =>
      item.geometries.map((geom) => ({
        expressId: item.expressId,
        globalId: item.globalId,
        geometryExpressId: geom.geometryExpressID,
        polygon: computeFootprintPolygon({
          vertexData: geom.vertexData,
          indexData: geom.indexData,
          transform: geom.transformationMatrix,
          expressId: item.expressId,
          globalId: item.globalId,
        }),
      }))
    )
);
